<template>
  <div class="reg-field">
    <div class="reg-field-label" v-show="label">
      <span :class="{ required: required }" v-show="required">*</span
      ><span>{{ label }}</span>
    </div>
    <div class="reg-field-value">
      <div class="reg-field-body">
        <input :type="stype" :placeholder="splaceholder" :value="svalue" />
      </div>
      <slot></slot>
    </div>
    <div class="reg-field-text" v-show="subTitle">{{ subTitle }}</div>
    <div class="reg-field-message" v-show="message">{{ message }}</div>
  </div>
</template>
<script>
export default {
  name: "regField",
  props: {
    svalue: {},
    splaceholder: {
      type: String,
      default: "",
    },
    stype: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: true,
    },
    message: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss">
</style>